import type { File } from "../files";
import type { Product } from "../products";

export type DeliveryCarrier =
  "FEDEX_TNT" | "BIP" | "CIBLEX" | "UPS" | "STERNE" | "CHRONOPOST";
export const DeliveryCarrierEnum: Record<DeliveryCarrier, DeliveryCarrier> = {
  FEDEX_TNT: "FEDEX_TNT",
  BIP: "BIP",
  CIBLEX: "CIBLEX",
  UPS: "UPS",
  STERNE: "STERNE",
  CHRONOPOST: "CHRONOPOST",
} as const;

export type PickupCarrier = "FEDEX_TNT" | "BIP" | "CIBLEX" | "UPS" | "STERNE";
export const PickupCarrierEnum: Record<PickupCarrier, PickupCarrier> = {
  FEDEX_TNT: "FEDEX_TNT",
  BIP: "BIP",
  CIBLEX: "CIBLEX",
  UPS: "UPS",
  STERNE: "STERNE",
} as const;

export const SexEnum = {
  male: "MALE",
  female: "FEMALE",
  notIndicated: "NOT_INDICATED",
} as const;

export type Sex = (typeof SexEnum)[keyof typeof SexEnum];

export const OrderStatusEnum = {
  needToBeProcessed: "NEED_TO_BE_PROCESSED",
  draft: "DRAFT",
  confirmed: "CONFIRMED",
  waitingForProduction: "WAITING_FOR_PRODUCTION",
  producing: "PRODUCING",
  producingInTransit: "PRODUCING_IN_TRANSIT",
  opsShippingToday: "OPS_SHIPPING_TODAY",
  shipped: "SHIPPED",
  delivered: "DELIVERED",
  onHold: "ON_HOLD",
  shippedBackFromDoctor: "SHIPPED_BACK_FROM_DOCTOR",
} as const;

export type OrderStatus =
  (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];

export interface Patient {
  firstName: string;
  lastName: string;
  birthDate?: Date;
  sex?: Sex;
}

export interface Dentist {
  id: string;
  firstName?: string;
  lastName?: string;
}

export interface OrderInfo {
  dentistId: string;
  patient: Patient;
}

export interface OrderComment {
  id: string;
  comment: string;
  createdAt: Date;
  files: File[];
}

export interface DentalOffice {
  id: string;
  name: string;
  deliveryCarrier?: DeliveryCarrier;
  pickupCarrier?: PickupCarrier;
}

export interface Order {
  reference?: string;
  status: OrderStatus;
  deliveryDate: Date;
  dentist: Dentist;
  patient: Patient;
  products: Product[];
  comments: OrderComment[];
  files: File[];
  dentalOffice: DentalOffice;
}
